import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import style from "./CustomTable.module.css";
import React from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import DownloadIcon from "@mui/icons-material/Download";
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, Grid, Pagination, Switch, Chip } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import moment from "moment";
import { Link } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import VideoThumbnail from "react-video-thumbnail";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { Tooltip } from "@mui/material";
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';

import { useState } from "react";
const CustomTable = ({
  data,
  columns,
  pageNo,
  pageLimit,
  handleEdit,
  handleDelete,
  handleManageAvailability,
  handleActive,
  handleFreeUser,
  handleDisplay,
  handlePageChange,
  pageNumber,
  pageCount,
  loading,
  totalData,
  perPage,
  handleCheckStatus,
  handleManualTrigger,
  handleImageUpload,
  customRender,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [language, setLanguage] = useState('ENGLISH');
  
  
  const handleOpenModal = (asset) => {
    setSelectedAsset(asset);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedAsset(null);
  };

  const handleDownload = (url) => {
    console.log("url", url);
    // Check if url is an array and take the first element
    if (Array.isArray(url)) {
        url = url[0]; // Take the first URL in the array
    }
    // Proceed only if url is a string
    if (typeof url === "string") {
        const link = document.createElement('a');
        link.href = url;
        link.download = url.split('/').pop(); // Get filename from URL
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    } else {
        console.error("Invalid URL:", url);
    }
};

  const handlePageChangePagination = (event, value) => {
    handlePageChange(value);
  };

  let page = pageNumber ? pageNumber : 1;
  let limit = pageLimit ? pageLimit : 10;
  let count = pageCount ? pageCount : 1;


   // Calculate the range
  //  const startIndex = (pageNumber - 1) * perPage + 1 || 1;
    const endIndex = Math.min(pageNumber * perPage, totalData);
    // Calculate the range
const startIndex = totalData > 0 ? (pageNumber - 1) * perPage + 1 : 0;
// const endIndex = totalData > 0 ? Math.min(pageNumber * perPage, totalData) : 0;


  const getNestedProperty = (obj, path) => {
    const keys = path.split(".");
    let result = obj;

    for (const key of keys) {
      if (result === undefined) {
        return "--";
      } else result = obj ? obj[key] : "--";
    }

    return result;
  };

  const formatGender = (gender) => {
    if (!gender) return "";
    return gender.charAt(0).toUpperCase() + gender.slice(1).toLowerCase();
  };
  const getSpecialityText = (speciality, lang) => {
    if (!speciality) return "--";
   
    // Check if speciality is an array (Doctor Table case)
    if (Array.isArray(speciality)) {
      return speciality.map(s => lang === 'ENGLISH' ? s.speciality : s.hindiSpeciality).join(", ");
    }
  
    // Check if speciality is an object (Speciality Table case)
    return lang === 'ENGLISH' ? speciality : speciality.hindiSpeciality;
  };
  
  return (
    <>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "70vh",
          }}
        >
          {/* <CircularProgress /> */}
          <img src={process.env.PUBLIC_URL + "/Loader.gif"} alt="Loading..." />
        </div>
      ) : (
        <>
          <TableContainer component={Paper} className={style.main_div}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column, index) => (
                    <TableCell
                      key={index}
                      align={column.align}
                      sx={{ fontWeight: "bolder", minWidth: column.minWidth }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.map((row, rowIndex) => (
                  <TableRow key={rowIndex}>
                    {columns.map((column, columnIndex) => (
                      <TableCell key={columnIndex} align={column.align}>
                        {customRender && typeof customRender[column.id] === 'function'
                          ? customRender[column.id](row[column.id], row)
                          : column.id === "city" ? (
                          row?.city?.split(",").map((city, index, arr) => (
                            <div key={index}>
                              {city}
                              {index < arr.length - 1 && ','}
                            </div>
                          ))
                        ) : column.id === "speciality" 
                        ? getSpecialityText(row.speciality, language
                        ): column.id === "optInPersonConsultant" 
                          ? (row.optInPersonConsultant ? "Yes" : "No")
                        : column.id === "doctors" ? (
                          row.doctors?.filter(doctor => doctor).map((doctor, docIndex) => (
                            <div key={docIndex}>
                              <span key={docIndex}>
                                {doctor?.fullname || "Unknown Doctor"}
                                {docIndex < (row.doctors?.filter(doctor => doctor).length || 0) - 1 && ", "}
                              </span>
                            </div>
                          )) || <span>No doctors assigned</span>
                        ) :  column.id === "action" ? (
                          <>
                            <div
                              style={{
                                display: "flex",
                                // justifyContent: "",
                              }}
                            >
                              {(row?.action?.edit || handleEdit) && (
                                <div
                                  onClick={() => {
                                    // Handle edit action for this row
                                    console.log("+++++++", row);
                                    handleEdit(row);
                                  }}
                                >
                                     <Tooltip title="Edit">
                                  <IconButton>
                                    <EditIcon
                                      style={{
                                        fontSize: "24px",
                                        borderRadius: "3px",
                                        cursor: "pointer",
                                        color: "green",
                                      }}
                                    />
                                  </IconButton>
                                </Tooltip>
                                </div>
                              )}
                              {(row?.action?.delete || handleDelete) && (
                                <div
                                  onClick={() => {
                                    // Handle delete action for this row
                                    handleDelete(row);
                                  }}
                                >
                                  <Tooltip title="Delete">
                                  <IconButton>
                                    <DeleteIcon
                                      style={{
                                        fontSize: "24px",
                                        borderRadius: "3px",
                                        cursor: "pointer",
                                        color: "red",
                                      }}
                                    />
                                  </IconButton>
                                  </Tooltip>
                                </div>
                              )}
                              {row?.action?.status && handleCheckStatus && (
                                <div
                                  onClick={() => {
                                    handleCheckStatus(row.patient?._id || row.patient);
                                  }}
                                >
                                  <Tooltip title="Check Status">
                                  <IconButton>
                                    <PlayArrowIcon
                                      style={{
                                        fontSize: "24px",
                                        borderRadius: "3px",
                                        cursor: "pointer",
                                        color: "orange",
                                      }}
                                    />
                                  </IconButton>
                                  </Tooltip>
                                </div>
                              )}
                              {row?.action?.generate && handleManualTrigger && (
                                <div
                                  onClick={() => {
                                    handleManualTrigger(row.patient?._id || row.patient);
                                  }}
                                >
                                  <Tooltip title="Generate New Plan">
                                  <IconButton>
                                    <PlayArrowIcon
                                      style={{
                                        fontSize: "24px",
                                        borderRadius: "3px",
                                        cursor: "pointer",
                                        color: "blue",
                                      }}
                                    />
                                  </IconButton>
                                  </Tooltip>
                                </div>
                              )}
                             {row?.action?.manageAvailability && row.optInPersonConsultant && (
  <div onClick={() => handleManageAvailability(row)}>
    <Tooltip title="Manage Availability">
    <IconButton>
      <CalendarMonthIcon
        style={{
          fontSize: "24px",
          borderRadius: "3px",
          cursor: "pointer",
          color: "blue",
        }}
      />
    </IconButton>
    </Tooltip>
  </div>
)}


                            </div>
                          </>
                        ) : column.id === "S.No" ? (
                          ++rowIndex + (page - 1) * limit
                        ) : column.id === "title" ? (
                          row?.title.length > 40 ? (
                            <p>{row?.title.substring(0, 40) + "..."}</p>
                          ) : (
                            <p>{row?.title}</p>
                          )
                        ) : column.id === "doctorId.fullname" ? (
                          row?.doctorId?.fullname ? (
                            row?.doctorId?.fullname?.length > 40 ? (
                              <p>{row?.doctorId?.fullname.substring(0, 40) + "..."}</p>
                            ) : (
                              <p>{row?.doctorId?.fullname}</p>
                            )
                          ) : (
                            <p>Unknown Doctor</p>
                          )
                        ): column.id === "patientId.fullname" ? (
                          row?.patientId?.fullname ? (
                            row?.patientId?.fullname?.length > 40 ? (
                              <p>{row?.patientId?.fullname.substring(0, 40) + "..."}</p>
                            ) : (
                              <p>{row?.patientId?.fullname}</p>
                            )
                          ) : (
                            <p>Unknown Patient</p>
                          )
                        ): column.id === "patient.fullname" ? (
                          row?.patient?.fullname ? (
                            row?.patient?.fullname?.length > 40 ? (
                              <p>{row?.patient?.fullname.substring(0, 40) + "..."}</p>
                            ) : (
                              <p>{row?.patient?.fullname}</p>
                            )
                          ) : (
                            <p>Unknown Patient</p>
                          )
                        ): column.id === "mealPlan.dietType" ? (
                          row?.mealPlan?.dietType?.length > 40 ? (
                            <p>{row?.mealPlan?.dietType.substring(0, 40) + "..."}</p>
                          ) : (
                            <p>{row?.mealPlan?.dietType}</p>
                          )
                        ): column.id === "specialityId.speciality" ? (
                          row?.specialityId?.speciality?.length > 40 ? (
                            <p>{row?.specialityId?.speciality.substring(0, 40) + "..."}</p>
                          ) : (
                            <p>{row?.specialityId?.speciality}</p>
                          )
                        ): column.id === "patientId.phone" ? (
                          row?.patientId?.phone ? (
                            row?.patientId?.phone?.length > 40 ? (
                              <p>{row?.patientId?.phone.substring(0, 40) + "..."}</p>
                            ) : (
                              <p>{row?.patientId?.phone}</p>
                            )
                          ) : (
                            <p>N/A</p>
                          )
                        ): column.id === "doctorId.consultationFee" ? (
                          row?.doctorId?.consultationFee !== undefined && row?.doctorId?.consultationFee !== null ? (
                            String(row?.doctorId?.consultationFee).length > 40 ? (
                              <p>{String(row?.doctorId?.consultationFee).substring(0, 40) + "..."}</p>
                            ) : (
                              <p>{row?.doctorId?.consultationFee}</p>
                            )
                          ) : (
                            <p>N/A</p>
                          )
                        ): column.id === "doctorId.processingFee" ? (
                          row?.doctorId?.processingFee !== undefined && row?.doctorId?.processingFee !== null ? (
                            String(row?.doctorId?.processingFee).length > 40 ? (
                              <p>{String(row?.doctorId?.processingFee).substring(0, 40) + "..."}</p>
                            ) : (
                              <p>{row?.doctorId?.processingFee}</p>
                            )
                          ) : (
                            <p>N/A</p>
                          )
                        ): column.id === "category.title" ? (
                          row?.title.length > 40 ? (
                            <p>{row?.categoryTitle.substring(0, 40) + "..."}</p>
                          ) : (
                            <p>{row?.categoryTitle}</p>
                          )
                        ) : column.id === "subCategory.title" ? (
                          row?.title.length > 40 ? (
                            <p>
                              {row?.subCategoryTitle.substring(0, 40) + "..."}
                            </p>
                          ) : (
                            <p>{row?.subCategoryTitle}</p>
                          )
                        ) : column.id === "status" ? (
                          <div style={{ textAlign: "center" }}>
                            <Switch
                              checked={(row.status || "").toString().toLowerCase() === "active"}
                              onChange={(event) => {
                                const newActive = event.target.checked;
                                if (typeof handleActive === 'function') {
                                  handleActive(row?._id, newActive);
                                }
                              }}
                            />
                          </div>
                        ) : column.id === "attachedFile" ? (
                          <div style={{ textAlign: "center" }}>
                            {row.attachedFile ? (
                              <>
                                <Tooltip title="Preview">
                                  <IconButton onClick={() => handleOpenModal(row.attachedFile)}>
                                    <VisibilityIcon style={{ color: "#1976d2" }} />
                                  </IconButton>
                                </Tooltip>
                              </>
                            ) : (
                              <span>--</span>
                            )}
                          </div>
                        ) : column.id === "generate" ? (
                          <div style={{ textAlign: "center" }}>
                            <Button
                              variant="outlined"
                              size="small"
                              onClick={() => handleManualTrigger && handleManualTrigger(row.patient?._id || row.patient)}
                              disabled={!handleManualTrigger}
                            >
                              Generate
                            </Button>
                          </div>
                        ) : column.type === "IMAGE" ? (
                          <>
                            {row?.assets?.toString().includes("mp4") ? (
                              <div
                                style={{
                                  width: "150px",
                                  height: "100px",
                                  overflow: "hidden",
                                }}
                              >
                                <VideoThumbnail
                                  videoUrl={row?.assets}
                                  height={100}
                                  width={150}
                                />
                              </div>
                            ) : (
                              <>
                                {row?.assets?.toString().includes("pdf") ? (
                                  <img
                                    src="/assets/pdf.svg"
                                    alt="banner"
                                    style={{ width: "150px", height: "100px" }}
                                  />
                                ) : (
                                  <img
                                    src={getNestedProperty(row, column.id)}
                                    alt="banner"
                                    style={{ width: "150px", height: "100px" }}
                                  />
                                )}
                              </>
                            )}
                          </>
                        ) : column.type === "thumbnail" ? (
                          row.thumbnail ? (
                            <img
                              src={row.thumbnail}
                              alt="thumbnail"
                              style={{ width: "150px", height: "100px", cursor: "pointer" }}
                              onClick={() => handleOpenModal(row.thumbnail)}
                            />
                          ) : (
                            <p>--</p>
                          )
                        ) : column.type === "categoryIcon" ? (
                          row.categoryIcon ? (
                            <img
                              src={row.categoryIcon}
                              alt="categoryIcon"
                              style={{ width: "150px", height: "100px", cursor: "pointer" }}
                              onClick={() => handleOpenModal(row.categoryIcon)}
                            />
                          ) : (
                            <p>--</p>
                          )
                        ) : column.type === "image" ? (
                          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 }}>
                            <div style={{ position: 'relative' }}>
                              {row.image ? (
                                <img
                                  src={row.image}
                                  alt={row.patientName || 'Food item'}
                                  style={{ 
                                    width: "60px", 
                                    height: "60px", 
                                    objectFit: 'cover',
                                    borderRadius: 8,
                                    border: '1px solid #e0e0e0',
                                    cursor: "pointer" 
                                  }}
                                  onClick={() => handleOpenModal(row.image)}
                                  onError={(e) => {
                                    e.target.style.display = 'none';
                                    e.target.nextSibling.style.display = 'flex';
                                  }}
                                />
                              ) : null}
                              <div
                                style={{
                                  width: 60,
                                  height: 60,
                                  display: row.image ? 'none' : 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  backgroundColor: '#f5f5f5',
                                  borderRadius: 8,
                                  border: '1px solid #e0e0e0',
                                  color: '#999',
                                  fontSize: '12px',
                                  textAlign: 'center'
                                }}
                              >
                                No Image
                              </div>
                            </div>
                            {handleImageUpload && (
                              <IconButton
                                size="small"
                                onClick={() => handleImageUpload(row)}
                                sx={{ 
                                  padding: '4px',
                                  backgroundColor: '#f0f0f0',
                                  '&:hover': {
                                    backgroundColor: '#e0e0e0'
                                  }
                                }}
                                title="Upload Image"
                              >
                                <PhotoCameraIcon fontSize="small" />
                              </IconButton>
                            )}
                          </div>
                        ):column.type === "VIDEO" ? (
                          <>
                            {row?.assets?.toString().includes("pdf") ? (
                              <img
                                src="/assets/pdf.svg"
                                alt="banner"
                                style={{ width: "150px", height: "100px", cursor: "pointer" }}
                                onClick={() => handleOpenModal(row?.assets)}
                              />
                            ) : row?.assets?.toString().includes("mp4") || row?.videoUrl ? (
                              <div
                                style={{
                                  width: "150px",
                                  height: "100px",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  backgroundColor: "#000",
                                  position: "relative",
                                  cursor: "pointer",
                                }}
                                onClick={() => handleOpenModal(row?.assets || row?.videoUrl)}
                              >
                                {/* Video Play Icon */}
                                <PlayArrowIcon
                                  style={{
                                    fontSize: "50px",
                                    color: "#fff",
                                    position: "absolute",
                                  }}
                                />
                              </div>
                            ) : (
                              <img
                                src={row?.assets}
                                alt="thumbnail"
                                style={{ width: "150px", height: "100px", cursor: "pointer" }}
                                onClick={() => handleOpenModal(row?.assets)}
                              />
                            )}
                          </>
                        ) : column.label === "Active" ? (
                          <Switch
                            checked={row[column.id]}
                            onChange={(event) => {
                              const newActiveValue = event.target.checked;
                              row[column.id] = newActiveValue;
                              handleActive(row?._id, newActiveValue, "active");
                            }}
                          />
                        ) : column.id === "isFreeUser" || column.label === "Free User" ? (
                          <Switch
                            checked={row.isFreeUser || row[column.id] || false}
                            onChange={(event) => {
                              const newFreeUserValue = event.target.checked;
                              if (typeof handleFreeUser === 'function') {
                                handleFreeUser(row?._id, newFreeUserValue);
                              }
                            }}
                            color="primary"
                          />
                        ) : column.label === "Published" ? (
                          <Switch
                            checked={row[column.id]}
                            disabled={true}
                            onChange={(event) => {
                              const newActiveValue = event.target.checked;
                              handleActive(
                                row?._id,
                                newActiveValue,
                                "published"
                              );
                            }}
                          />
                        ) : column.label === "Attachment" ? (
                          <Link to={row.document}>
                            <IconButton>
                              <DownloadIcon
                                onClick={() => {
                                  handleDisplay(row);
                                }}
                                style={{
                                  fontSize: "24px",
                                  borderRadius: "3px",
                                  cursor: "pointer",
                                  color: "#111",
                                }}
                              />
                            </IconButton>
                          </Link>
                        ):  column.id === "ibsAssessment.fileLocation" && row?.ibsAssessment?.fileLocation ? (
                          <Link to={row?.ibsAssessment?.fileLocation}>
                            <IconButton>
                              <DownloadIcon
                                onClick={() => {
                                  handleDisplay(row);
                                }}
                                style={{
                                  fontSize: "24px",
                                  borderRadius: "3px",
                                  cursor: "pointer",
                                  color: "#111",
                                }}
                              />
                            </IconButton>
                          </Link>
                        ) : column.id === "details" ? (
                          <div
                            onClick={() => {
                              handleDisplay(row);
                            }}
                          >
                            <VisibilityIcon
                              style={{
                                fontSize: "24px",
                                borderRadius: "3px",
                                cursor: "pointer",
                                color: "green",
                              }}
                            />
                          </div>
                        ) : column.id === "videos" ? (
                          <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            onClick={() => handleDisplay(row)}
                          >
                            View
                          </Button>
                        ) : column.label === "Vendor Email" ? (
                          row?.vendorId?.email
                        ) : column.id === "socialMediaLink" ? (
                          row?.socialMediaLink === true ? (
                            "YES"
                          ) : (
                            "NO"
                          )
                        ) : column.id === "ticketSystem" ? (
                          row?.ticketSystem === true ? (
                            "YES"
                          ) : (
                            "NO"
                          )
                        ) : column.id === "datetime" ? (
                          `${row?.startDate} - ${row?.startTime}`
                        ) : column.id === "enddatetime" ? (
                          `${row?.endDate} - ${row?.endTime}`
                        ) : column.id === "createdAt" ? (
                          moment.utc(row?.createdAt).format("DD-MM-YYYY")
                        ) : column.id === "date" ? (
                          moment.utc(row?.date).format("DD-MM-YYYY")
                        ): column.id === "startDate" ? (
                          moment.utc(row?.startDate).format("DD-MM-YYYY")
                        ) : column.id === "endDate" ? (
                          moment.utc(row?.endDate).format("DD-MM-YYYY")
                        ) : column.id === "dob" ? (
                          moment.utc(row?.dob).format("DD-MM-YYYY")
                        ) : column.label === "Current Subscription" ? (
                          row?.activeSubscription ? (
                            row?.activeSubscription?.subscriptionTypeId?.name
                          ) : (
                            "InActive"
                          )
                        ) : column.label === "Subscription Expiry" ? (
                          row?.activeSubscription ? (
                            moment
                              .utc(row?.activeSubscription?.expiryDate)
                              .format("YYYY-MM-DD")
                          ) : (
                            "-"
                          )
                        ) : column.id === "vendorName" ? (
                          row?.vendorId?.fullName
                        ) : column.id === "addonName" ? (
                          row?.addon?.name
                        ) : column.id === "gender" ? ( // Transform gender to proper case
                          formatGender(row[column.id])
                        ) : column.id === "dietType" ? (
                          // Custom rendering for diet type with colored chip
                          <Chip
                            label={row[column.id] === "traditional" ? "Traditional" : 
                                   row[column.id] === "low_fodmap" ? "Low FODMAP" : 
                                   "Unknown"}
                            color={row[column.id] === "traditional" ? "primary" : 
                                   row[column.id] === "low_fodmap" ? "secondary" : 
                                   "default"}
                            size="small"
                            variant="outlined"
                          />
                        ) : column.id === "coreCategory" ? (
                          <Chip
                            label={row[column.id]}
                            color="primary"
                            size="small"
                            variant="outlined"
                          />
                        ) : column.id === "category" ? (
                          <Chip
                            label={row[column.id]}
                            color="secondary"
                            size="small"
                            variant="outlined"
                          />
                        ) : column.id === "subCategory" ? (
                          <Chip
                            label={row[column.id]}
                            color="success"
                            size="small"
                            variant="outlined"
                          />
                        ) : column.id === "fodmap" ? (
                          (() => {
                            const value = row[column.id];
                            let color = "default";
                            if (value === "Low") color = "success";
                            else if (value === "Medium") color = "warning";
                            else if (value === "Moderate") color = "warning";
                            else if (value === "High") color = "error";
                            
                            return (
                              <Chip
                                label={value}
                                color={color}
                                size="small"
                                variant="outlined"
                              />
                            );
                          })()
                        ) : column.id === "phase" ? (
                          // Custom rendering for phase with colored chip
                          row.dietType === "low_fodmap" ? (
                            <Chip
                              label={row[column.id] === "elimination" ? "Elimination" :
                                     row[column.id] === "introduction" ? "Introduction" :
                                     row[column.id] === "maintenance" ? "Maintenance" :
                                     "N/A"}
                              color={row[column.id] === "elimination" ? "error" :
                                     row[column.id] === "introduction" ? "warning" :
                                     row[column.id] === "maintenance" ? "success" :
                                     "default"}
                              size="small"
                              variant="outlined"
                            />
                          ) : (
                            <Chip
                              label="N/A"
                              color="default"
                              size="small"
                              variant="outlined"
                            />
                          )
                        ) : (
                          getNestedProperty(row, column.id)
                        )}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Grid 
            container 
            pt={3}
            sx={{
              display: 'flex',
              alignItems: 'center',
              position: 'relative'
            }}
          >
            <Grid 
              item 
              xs={12} 
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              {startIndex ? <Pagination
                count={count}
                page={page}
                onChange={handlePageChangePagination}
              />: ""}
            </Grid>
            <div style={{ 
              position: 'absolute',
              right: 0,
              display: 'flex',
              alignItems: 'center',
              height: '100%',
              paddingRight: '16px'
            }}>
              {startIndex ? <p>Showing {startIndex}-{endIndex} of {totalData} records</p>: ''}
            </div>
          </Grid>
          <Dialog 
  open={openModal} 
  onClose={handleCloseModal} 
  maxWidth="lg" // Increase modal width
  fullWidth={true} // Make it take full width of maxWidth
>
  <DialogContent style={{ height: "600px" }}> {/* Increase modal height */}
    {selectedAsset ? (
      selectedAsset.toString().includes(".pdf") ? (
        <div style={{ position: "relative", height: "100%" }}>
          <CircularProgress style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }} />
          <iframe
            onLoad={(e) => e.target.previousSibling.remove()} // Remove loader after PDF loads
            src={`https://docs.google.com/viewer?url=${encodeURIComponent(selectedAsset[0])}&embedded=true`}
            title="PDF Preview"
            style={{ width: "100%", height: "100%", border: "none" }}
          />
        </div>
      ) : selectedAsset.toString().includes(".mp4") ? (
        <video controls style={{ width: "100%", height: "100%" }}>
          <source src={selectedAsset} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      ) : (
        <img
          src={selectedAsset}
          alt="Preview"
          style={{ width: "100%", height: "auto" }}
        />
      )
    ) : (
      <CircularProgress style={{ margin: "auto", display: "block" }} />
    )}
  </DialogContent>
  <DialogActions>
    <Button onClick={handleCloseModal} color="secondary">
      Close
    </Button>
    <Button
      onClick={() => handleDownload(selectedAsset)}
      color="primary"
      variant="contained"
    >
      Download
    </Button>
  </DialogActions>
</Dialog>

        </>
      )}
    </>
  );
};

export default CustomTable;
